import { inject, Injectable } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { AppStateModel } from '../../../app.state';
import { AuthenticationService } from '../../services/authentication.service';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { RouteNavigationService } from '../route-navigation.service';

@Injectable()
export class LoggedInRouteGuardLogic {
  constructor(
    private _store: Store,
    private _authenticationService: AuthenticationService,
    private _routeNavigationService: RouteNavigationService,
  ) {}

  public canActivate(): Observable<boolean> {
    return this._store
      .select<AppStateModel>((state) => state.AppState)
      .pipe(
        filter((state: AppStateModel) => !!state?.isInitialized),
        take(1),
        map((applicationState: AppStateModel) => {
          if (!applicationState.isUserLoggedIn) {
            this._routeNavigationService.goToLoginAsync(true);
          }

          return applicationState.isUserLoggedIn;
        }),
      );
  }
}

export const LoggedInRouteGuard: CanActivateFn = (): Observable<boolean> => {
  return inject(LoggedInRouteGuardLogic).canActivate();
};
